import SettingsModal from "./view";
export default SettingsModal;